'use es6';

export const LOW = 300;
export const MEDIUM = 500;
export const HIGH = 700;
export default {
  LOW,
  MEDIUM,
  HIGH
};